import { createContext, useContext, ReactNode } from 'react'
import { useWebSocket, WSMessage } from '../hooks/useWebSocket'

interface WebSocketContextType {
  isConnected: boolean
  lastMessage: WSMessage | null
  sendMessage: (message: WSMessage) => void
  sendEncryptedMessage: (recipientId: string, ciphertext: string) => void
  sendTyping: (recipientId: string) => void
  sendReadReceipt: (recipientId: string, messageIds: string[]) => void
  sendRTCOffer: (targetId: string, sdp: string, callType?: 'audio' | 'video') => void
  sendRTCAnswer: (targetId: string, sdp: string) => void
  sendICECandidate: (targetId: string, candidate: RTCIceCandidate) => void
  disconnect: () => void
}

const WebSocketContext = createContext<WebSocketContextType | null>(null)

export function WebSocketProvider({ token, children }: { token: string | null; children: ReactNode }) {
  const ws = useWebSocket(token)

  return (
    <WebSocketContext.Provider value={ws}>
      {children}
    </WebSocketContext.Provider>
  )
}

export function useSharedWebSocket(): WebSocketContextType {
  const context = useContext(WebSocketContext)
  if (!context) {
    throw new Error('useSharedWebSocket must be used within WebSocketProvider')
  }
  return context
}
